import { render, staticRenderFns } from "./AllocationHistory.vue?vue&type=template&id=3d7c2a1f"
import script from "./AllocationHistory.vue?vue&type=script&lang=js"
export * from "./AllocationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports